import React, { useState } from "react";

/* eslint-disable react/prop-types */

export default function MCQElement({ element, onActions }) {
  const [selected, setSelected] = useState(null);

  const { question = "", image, choices = [], explanation = "" } = element;

  const handlePick = (choice) => {
    if (selected !== null) return;
    setSelected(choice.id);
    if (choice.actions && choice.actions.length > 0) {
      setTimeout(() => onActions(choice.actions), 800);
    }
  };

  return (
    <div className="sce-mcq">
      {image && (
        <div className="sce-mcq__img-wrap">
          <img src={image} alt="" className="sce-mcq__img" />
        </div>
      )}

      <p className="sce-mcq__question">{question}</p>

      <div className="sce-mcq__choices">
        {choices.map((choice) => {
          const isPicked = selected === choice.id;
          return (
            <button
              key={choice.id}
              type="button"
              disabled={selected !== null}
              aria-pressed={isPicked}
              className={`sce-mcq__choice${isPicked ? " sce-mcq__choice--selected" : ""}`}
              onClick={() => handlePick(choice)}
            >
              {choice.text}
            </button>
          );
        })}
      </div>

      {selected !== null && explanation && (
        <div className="sce-mcq__explanation">
          <p>{explanation}</p>
        </div>
      )}
    </div>
  );
}
